module.exports = __webpack_public_path__ + "img/wallet-icon.719d72d2.svg";